export const CONTROL_REPAIRER_DOMAIN_KEY = 'controlRepairer';
